const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Assessment',
      description: 'We analyze your current infrastructure, identify pain points, and understand your business objectives.',
    },
    {
      number: '02',
      title: 'Strategy & Planning',
      description: 'Our experts develop a customized roadmap with clear milestones and measurable outcomes.',
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'We execute the plan with precision, ensuring minimal disruption to your operations.',
    },
    {
      number: '04',
      title: 'Optimization & Support',
      description: 'Continuous monitoring and improvement to maximize performance and ROI.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-slate-900 mb-4">
            Our Process
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A proven methodology that delivers results every time
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow h-full border border-gray-100">
                <div className="text-6xl font-bold text-cyan-500/20 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-cyan-500 text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;